import React, { useEffect, useState, useImperativeHandle } from 'react';
import { Button, Modal } from "antd";
import selectImag from '../../../../../assets/teacherCare/select.png'
import styles from './index.less';

const SelectFrontCover = props => {
  const { backlist,
    form,
    selectCard, onChange, preview, onRef } = props
  const [visible, setVisible] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null)

  // 已选中的图片
  const selectedImag = () => {
    setSelectedCard({
      id: (selectCard || {}).backgroundId,
      url: (selectCard || {}).bgOneUrl,
      urlTow: (selectCard || {}).bgTwoUrl
    })
  }

  // 预览传值
  const handelPreview = () => {
    const item = {
      show: true,
      data: {
        ...selectedCard
      }
    }
    preview(item)
  }

  // 传递函数给父组件
  useImperativeHandle(onRef, () => {
    return {
      handelPreview
    }
  })

  // 确认选中封面
  const handleOnOk = () => {
    if (onChange) {
      onChange(selectedCard);
    }
    setVisible(false);
  };

  // 进入页面初始化值
  useEffect(() => {
    selectedImag()
    handleOnOk()
  }, [selectCard])

  // 取消选择
  const handleCancel = () => {
    setVisible(false);
    selectedImag()
  };

  // 修改modal可见状态
  const handleVisibleChange = (status) => {
    setVisible(status);
  };

  // 选中已有封面
  const handleCoverSelected = (id, url, url2) => {
    setSelectedCard({
      id,
      url,
      urlTow: url2,
    })
  };

  const { getFieldValue } = form;

  const mCoverInfo = getFieldValue('coverInfo');
  return (
    <div className={styles.poster_index_root}>
      {/* 选择按钮 */}
      <div className='btn-container'>
        <Button
          onClick={() => handleVisibleChange(true)}
        >
          {mCoverInfo && mCoverInfo.coverUrl ? '修改' : '选择'}
        </Button>

      </div>

      {/* 渲染已选中的封面 */}
      <div className='checked-item'>
        <div
          className='item-img'
          style={{
            backgroundImage: `url(${(selectedCard || {}).url})`
          }}
        />
      </div>

      <Modal
        width={680}
        className='poster-cover-modal'
        title='贺卡背景'
        visible={visible}
        onCancel={handleCancel}
        onOk={handleOnOk}
        okButtonProps={{ disabled: !selectedCard }}
        cancelText='取消'
        okText='确定'
      >
        <div className='cover-list'>
          {(backlist || []).map(({ id, bgOneUrl, bgName, bgTwoUrl }) => {
            const coverItem = (id === (selectedCard || {}).id) ? 'checked' : 'un-checked'
            return (
              <div
                className={`cover-item ${coverItem}`}
                key={id}
                onClick={() => handleCoverSelected(id, bgOneUrl, bgTwoUrl)}
              >
                <img src={selectImag} className={`selectImag ${coverItem}`} alt="" />
                <div className={`img ${coverItem}`}>
                  <img alt="" src={bgOneUrl} />
                </div>
                <div className='cover-backname'>{bgName}</div>
              </div>
            )
          })}
        </div>
      </Modal>
    </div>
  );
}
export default SelectFrontCover;
